import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {AuthService} from './auth.service';
import {SessionStorageService} from './session-storage.service';
import {Observable} from 'rxjs/Observable';

@Injectable({
    providedIn: 'root'
})
export class AuthGaurd implements CanActivate, CanActivateChild {
    tabData;

    constructor(private router: Router,
                private auth: AuthService,
                private sessionStorageService: SessionStorageService) {
        this.tabData = [];
        // sessionStorageService.setTabSession([]);
    }

    canActivate(next: ActivatedRouteSnapshot) {
        this.sessionStorageService.getUserSession() == null ? this.router.navigateByUrl('/sessions/signin') : true;
        return true;
    }

    setTabData(next: ActivatedRouteSnapshot) {
        let url = '';
        url += '/' + next.url.map((segment: any) => segment.path).join('/');
        const URL = url.replace('/', '').split('/');

        if (typeof next['data']['breadcrumb'] != 'undefined' && next['data']['breadcrumb'] !== 'Dashboard') {
            this.tabData = this.sessionStorageService.getTabSession() == null ? [] : this.sessionStorageService.getTabSession();
            let flag;
            jQuery.each(this.tabData, function (i, val) {
                val['status'] = 'inactive';
                if (val['name'] === next['data']['breadcrumb']) {
                    val['status'] = 'active';
                    val['url'] = next['_routerState']['url'];
                    val['label'] = next.data.breadcrumb.toUpperCase();
                    val['icon'] = next.data.icon;
                    val['initialRoute'] = next.outlet == 'primary' ? '/' + URL[URL.length - 2] : '/' + next.outlet;
                    val['outlets'] = {outlets: {[next.outlet]: URL[URL.length - 1]}};
                    flag = true;
                }
            });
            if (!flag) {
                this.tabData.push({
                    name: next['data']['breadcrumb'],
                    url: next['_routerState']['url'],
                    status: 'active',
                    label: next.data.breadcrumb.toUpperCase(),
                    icon: next.data.icon,
                    initialRoute: next.outlet == 'primary' ? '/' + URL[URL.length - 2] : '/' + next.outlet,
                    outlets: {outlets: {[next.outlet]: URL[URL.length - 1]}},
                });
            }
            this.sessionStorageService.setTabSession(this.tabData);
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        this.setTabData(childRoute);
        return true;
    }
}
